import { toast } from 'sonner';
import { BASE_URL } from '../../constants/apiPaths';
import { auth, getAccessToken } from '../../firebase';
import axios from 'axios';

const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};
// GET /organisation/event/bounty?eventId=<eventId></eventId>
export const getAchievments = async () => {
    try {
        const url = `${BASE_URL}/citizen/achievement`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};
// GET /citizen/acitivityHistory?page=<page_number>&entriesPerPage=<per_page_entry_count></per_page_entry_count>

export const getActivityHistory = async (pageNo, entriesPerPage) => {
    try {
        const url = `${BASE_URL}/citizen/activityHistory?page=${pageNo}&entriesPerPage=${entriesPerPage}`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        console.log(response, 'this is the response after adding entry');
        if (response.status === 200 || response.status === 201) {
            return {
                data: response?.data?.entries,
                entryCount: response?.data?.entryCount,
            };
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

export const getAchievmentImpactPoints = async () => {
    try {
        const url = `${BASE_URL}/citizen/achievementImpactPoints`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};
